import { Controller } from "@hotwired/stimulus"

// Lifts the compose bar above the iOS keyboard in Hotwire Native using visualViewport.
export default class extends Controller {
    connect() {
        if (!document.body.classList.contains("turbo-native")) return
        if (!window.visualViewport) return

        this._onViewportChange = () => this.sync()
        window.visualViewport.addEventListener("resize", this._onViewportChange)
        window.visualViewport.addEventListener("scroll", this._onViewportChange)
        this.sync()
    }

    disconnect() {
        if (!this._onViewportChange || !window.visualViewport) return
        window.visualViewport.removeEventListener("resize", this._onViewportChange)
        window.visualViewport.removeEventListener("scroll", this._onViewportChange)
        document.documentElement.style.removeProperty("--native-keyboard-offset")
    }

    sync() {
        const viewport = window.visualViewport
        if (!viewport) return
        const offset = Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop)
        document.documentElement.style.setProperty("--native-keyboard-offset", `${offset}px`)
    }
}
